import { render, staticRenderFns } from "./data-view.vue?vue&type=template&id=e304bfc6&scoped=true"
import script from "./data-view.vue?vue&type=script&lang=js"
export * from "./data-view.vue?vue&type=script&lang=js"
import style0 from "./data-view.vue?vue&type=style&index=0&id=e304bfc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e304bfc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e304bfc6')) {
      api.createRecord('e304bfc6', component.options)
    } else {
      api.reload('e304bfc6', component.options)
    }
    module.hot.accept("./data-view.vue?vue&type=template&id=e304bfc6&scoped=true", function () {
      api.rerender('e304bfc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/data-view.vue"
export default component.exports